import ShortenURL from './ShortenURL.js';

/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace SocialMediaShare
 */
class SocialMediaShare {
    constructor() {
    }

    getFacebookShareHREF(URL) {
        return ShortenURL.getShortURL(URL, null).then(shortURL => {
            return "https://www.facebook.com/sharer/sharer.php?u=" + shortURL;
        });
    }

    getTwitterShareHREF(URL, text = "") {
        return ShortenURL.getShortURL(URL, null).then(shortURL => {
            return "https://twitter.com/intent/tweet?text=" + text + " " + shortURL;
        });
    }

    getPinterestShareHREF(URL, imgPath, description) {
        return ShortenURL.getShortURL(URL, null).then(shortURL => {
            return "http://pinterest.com/pin/create/button/?url=" + shortURL + "&amp;media=" + imgPath + "&amp;description=" + description;
        });
    }

    getEmailShareHREF(URL, description) {
        return ShortenURL.getShortURL(URL, null).then(shortURL => {
            return "mailto:?subject=" + description + "&amp;body=" + shortURL;
        });
    }
}

export default new SocialMediaShare();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/SocialMediaShare.js
// module id = 311
// module chunks = 0